import React from 'react';
import { SocialIcon } from 'react-social-icons';
import './SocialMedia.css'


const SocialMedia = () => {
  return (
    <div className="div-icons">
      <span className="icons"><SocialIcon network="linkedin" url="https://www.linkedin.com/in/davi-baltar-70476515a" target="_blank" style={{ height: 30, width: 30 }} bgColor="#fcfcfc" fgColor="#84a086" /></span>
      <span className="icons"><SocialIcon network="github" url="https://github.com/davibaltar" target="_blank" style={{ height: 30, width: 30 }} bgColor="#fcfcfc" fgColor="#84a086" /></span>
      <span className="icons"><SocialIcon network="behance" url="https://www.behance.net/davibaltar" target="_blank" style={{ height: 30, width: 30 }} bgColor="#fcfcfc" fgColor="#84a086" /></span>
      <span className="icons"><SocialIcon network="email" url="mailto:davibaltarx.npm@gmail.com" target="_blank" style={{ height: 30, width: 30 }} bgColor="#fcfcfc" fgColor="#84a086" /></span>
    </div>
  )
};

export default SocialMedia;